import { fetcher } from '@commenda/utils';

import { FilingConductorBulkUpdateResponse, ProcessedLogPipelineStatus, IntegrationWebhookLogStatus } from './types';

export interface UpdateDataflowStatusResult {
  success: boolean;
  data?: FilingConductorBulkUpdateResponse;
  error?: string;
}

export interface UpdateIntegrationWebhookLogStatusParams {
  rootFiCompanyId: number;
  ids: string[];
  status: IntegrationWebhookLogStatus;
  token?: string;
}

/** Bulk-updates the processing status of the selected IntegrationWebhookLog rows. */
export async function updateIntegrationWebhookLogStatus({ rootFiCompanyId, ids, status, token }: UpdateIntegrationWebhookLogStatusParams): Promise<UpdateDataflowStatusResult> {
  try {
    const response = await fetcher(
      `filing-conductor/integrations/${rootFiCompanyId}/webhook-logs/status`,
      { method: 'PATCH', body: { ids, status } },
      token
    );
    const json = await response.json();
    if (!response.ok) {
      return { success: false, error: json?.message || 'Failed to update status' };
    }
    return { success: true, data: json as FilingConductorBulkUpdateResponse };
  } catch (error) {
    return { success: false, error: error instanceof Error ? error.message : 'Failed to update status' };
  }
}

export interface UpdateProcessedLogStatusParams {
  corporationId: number;
  ids: string[];
  pipelineStatus: ProcessedLogPipelineStatus;
  token?: string;
}

/** Bulk-updates the pipelineStatus of the selected ProcessedLog rows. */
export async function updateProcessedLogStatus({ corporationId, ids, pipelineStatus, token }: UpdateProcessedLogStatusParams): Promise<UpdateDataflowStatusResult> {
  try {
    const response = await fetcher(
      `filing-conductor/corporations/${corporationId}/processed-logs/status`,
      { method: 'PATCH', body: { ids, pipelineStatus } },
      token
    );
    const json = await response.json();
    if (!response.ok) {
      return { success: false, error: json?.message || 'Failed to update status' };
    }
    return { success: true, data: json as FilingConductorBulkUpdateResponse };
  } catch (error) {
    return { success: false, error: error instanceof Error ? error.message : 'Failed to update status' };
  }
}
